/* eslint-disable no-unused-expressions */
import React from 'react';
import PopUp from '../PopUp/PopUp';
import * as PropertyBucket from '../../Properties/Properties'
import { getRemainingTokenTimeInSec } from "../../Helpers/utils";
import { handleLogOut } from "../../Helpers/SessionTimer";

/*
	Possibility to move timeout into redux in future. 
*/

export class SessionTimeoutWarning extends React.Component {
	constructor(props) {
		super(props);
		this.width = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) / -2;
		this.height = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) / 2;
	}

	showPopUp = (title, notification, onClickEvent, hideCloseButton = false) => {
		let popUp;
		popUp = <PopUp title={title}
		               notification={notification}
		               onClickEvent={onClickEvent}
					   closePopUp={() => {}}
					   className='popUp-session-timer'
					   priority="high"
					   positionX = {this.width}
					   positionY = {this.height}
					   refreshTokenPopup
					   hideCloseButton={hideCloseButton}
		/>;
		return popUp;
	};


	render() {
		const diff = getRemainingTokenTimeInSec(this.props.userTime);
		return (
			<>
				{diff <= 300 && this.showPopUp('Ostrzeżenie', PropertyBucket.getSessionTimeEndMessage(), () => {
					this.props.refreshSession()
				}, true)}

				{diff <= 10 && this.showPopUp('Komunikat', PropertyBucket.getLogOutMessage())}

				{diff <= 3 && handleLogOut()}
			</>
		);
	}
}
